import { Component } from "vue-property-decorator";
import Partners from "./Partners.vue";
import HomeBase from "../../CharginStations/components/Home";

@Component({
  components: {
    Partners,
  },
})
export default class Home extends HomeBase {
  protected documentTitle = "Kde Nabít? – Mapa nabíjecích stanic";
  protected documentDescr = "Největší česká mapa nabíjecích stanic s on-line napojením na největší poskytovatele nabíjení v Česku i zahraničí.";
}
